var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSearch28 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 28,
  height: 28,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M5 12.5a7.5 7.5 0 1 1 12.886 5.22l-.167.166A7.5 7.5 0 0 1 5 12.5Zm13.147 6.354a8.5 8.5 0 1 1 .707-.707l6.353 6.353-.707.707-6.353-6.354Z",
  clipRule: "evenodd"
})));
export { SvgSearch28 as ReactComponent };
export default __webpack_public_path__ + "b64f0efdd862fc18943612ea81226b53.svg";